import React from "react";

function TermsAndConditions() {
  return (
    // <div className="terms-container">
    //   <h1>Terms & Conditions</h1>
      
    //   <section>
    //     <h2>Introduction</h2>
    //     <p>
    //       This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
    //     </p>
    //   </section>

    //   <section>
    //     <h2>Platform Information</h2>
    //     <p>
    //       This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of domain name <a href="https://treelix.in/">https://treelix.in/</a> ('Website'), including the related mobile site and mobile application (hereinafter referred to as 'Platform').
    //     </p>
    //     <p>
    //       The Platform is owned by TREELIX AGRITECH & INDUSTRIES PVT LTD, a company incorporated under the Companies Act, 1956 with its registered office at:
    //       <address>
    //         Godown No:2 and 3, Floor No: Underground Building No./Flat No.: S No 256, Hissa No 7/1 Road/Street: Hinjewadi Phase 1, Near Vibgyor School Nearby Landmark: Infotech Park Sub Post Office Locality/Sub Locality: Hinjawadi City/Town/Village: Pune District: Pune State: Maharashtra PIN Code: 411057
    //       </address>
    //     </p>
    //   </section>

    //   <section>
    //     <h2>Agreement to Terms</h2>
    //     <p>
    //       By using the Platform, you agree to these Terms of Use. If you transact on the Platform, you are bound by the applicable policies and terms. The Platform Owner may modify these Terms at any time without notice, and it is your responsibility to review them periodically.
    //     </p>
    //   </section>

    //   <section>
    //     <h2>Accessing and Using the Platform</h2>
    //     <p>
    //       To access and use the Services, you agree to provide true, accurate, and complete information during and after registration. You are responsible for all actions taken through your registered account.
    //     </p>
    //     <p>
    //       The contents of the Platform and Services are proprietary to TREELIX AGRITECH & INDUSTRIES PVT LTD and are licensed to the company. Unauthorized use may result in legal actions.
    //     </p>
    //   </section>

    //   <section>
    //     <h2>Limitation of Liability</h2>
    //     <p>
    //       Neither we nor any third parties provide any warranty or guarantee regarding the accuracy, timeliness, or completeness of the information and materials on the website.
    //     </p>
    //   </section>

    //   <section>
    //     <h2>Indemnification</h2>
    //     <p>
    //       You agree to indemnify and hold harmless the Platform Owner, its affiliates, and their officers, directors, and employees from any claims or demands arising out of your breach of these Terms of Use.
    //     </p>
    //   </section>

    //   <section>
    //     <h2>Jurisdiction</h2>
    //     <p>
    //       Any disputes relating to these Terms will be governed by Indian law, and you consent to the exclusive jurisdiction of courts in Pune, Maharashtra.
    //     </p>
    //   </section>

    //   <section>
    //     <h2>Privacy Policy</h2>
    //     <p>
    //       This Privacy Policy describes how TREELIX collects, uses, shares, and protects your personal information through our Platform.
    //     </p>

    //     <h3>Collection of Data</h3>
    //     <p>
    //       We collect personal data when you use our Platform, such as your name, contact details, and transaction information. We may also collect sensitive personal data with your consent, such as financial details and biometric data.
    //     </p>

    //     <h3>Usage of Data</h3>
    //     <p>
    //       We use personal data to provide services, process transactions, and improve user experience. We may also use this data for marketing purposes, and you can opt-out at any time.
    //     </p>

    //     <h3>Sharing of Data</h3>
    //     <p>
    //       We may share your data with third-party service providers, sellers, or legal authorities as necessary to provide services, comply with laws, or prevent fraud.
    //     </p>

    //     <h3>Security of Data</h3>
    //     <p>
    //       We adopt reasonable security practices to protect your personal data from unauthorized access. However, the transmission of data over the internet is not entirely secure, and you accept the inherent risks.
    //     </p>

    //     <h3>Retention and Deletion of Data</h3>
    //     <p>
    //       You can delete your account at any time, and we will retain your personal data only as long as necessary or as required by law.
    //     </p>

    //     <h3>Your Rights</h3>
    //     <p>
    //       You can access, rectify, or update your personal data through the Platform. You can also withdraw consent for processing your data.
    //     </p>

    //     <h3>Changes to Privacy Policy</h3>
    //     <p>
    //       We may update this Privacy Policy from time to time. Significant changes will be notified to you.
    //     </p>
    //   </section>

    //   <section>
    //     <h2>Grievance Officer</h2>
    //     <p>
    //       Name: Aparna (Director) <br />
    //       Company Address: Godown No:2 and 3, Floor No: Underground Building No./Flat No.: S No 256, Hissa No 7/1 Road/Street: Hinjewadi Phase 1, Pune, Maharashtra, PIN: 411057 <br />
    //       Contact: +91 88550 67337 <br />
    //       Working Hours: Monday - Friday (9:00 AM - 6:00 PM)
    //     </p>
    //   </section>
    // </div>

    <div style={{lineHeight:2}}>
   
   <h1>Terms & Conditions</h1>

<section>This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
</section>

<p>This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of domain name https://treelix.in/ ('Website'), including the related mobile site and mobile application (hereinafter referred to as 'Platform').
</p>
<p>The Platform is owned by TREELIX AGRITECH & INDUSTRIES PVT LTD, a company incorporated under the Companies Act, 1956 with its registered office at Floor No.: Godown No:2 and 3,Floor No:Underground Building No./Flat No.: S No 256, Hissa No 7/1 Road/Street: Hinjewadi Phase 1, Near Vibgyor School Nearby Landmark: Infotech Park Sub Post Office Locality/Sub Locality: Hinjawadi City/Town/Village: Pune District: Pune State: Maharashtra PIN Code: 411057 ?Platform Owner?, 'we', 'us', 'our')..
</p>

<p>Your use of the Platform and services and tools are governed by the following terms and conditions (?Terms of Use?) as applicable to the Platform including the applicable policies which are incorporated herein by way of reference. If You transact on the Platform, You shall be subject to the policies that are applicable to the Platform for such transaction. By mere use of the Platform, You shall be contracting with the Platform Owner and these terms and conditions including the policies constitute Your binding obligations, with Platform Owner. These Terms of Use relate to your use of our website, goods (as applicable) or services (as applicable) (collectively, 'Services'). Any terms and conditions proposed by You which are in addition to or which conflict with these Terms of Use are expressly rejected by the Platform Owner and shall be of no force or effect. These Terms of Use can be modified at any time without assigning any reason. It is your responsibility to periodically review these Terms of Use to stay informed of updates..
</p>
<p>
For the purpose of these Terms of Use, wherever the context so requires ?you?, 'your' or ?user? shall mean any natural or legal person who has agreed to become a user/buyer on the Platform..

</p>
<p>
ACCESSING, BROWSING OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE, SO PLEASE READ THE TERMS OF USE CAREFULLY BEFORE PROCEEDING..

</p>
<p>
The use of Platform and/or availing of our Services is subject to the following Terms of Use:

</p>
<p>
To access and use the Services, you agree to provide true, accurate and complete information to us during and after registration, and you shall be responsible for all acts done through the use of your registered account on the Platform..

</p>
<p>
Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials offered on this website or through the Services, for any specific purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law..

</p>
<p>
Your use of our Services and the Platform is solely and entirely at your own risk and discretion for which we shall not be liable to you in any manner. You are required to independently assess and ensure that the Services meet your requirements..

</p>
<p>
The contents of the Platform and the Services are proprietary to us and are licensed to us. You will not have any authority to claim any intellectual property rights, title, or interest in its contents. The contents includes and is not limited to the design, layout, look and graphics..

</p>

<p>
You acknowledge that unauthorized use of the Platform and/or the Services may lead to action against you as per these Terms of Use and/or applicable laws..

</p>
<p>
You agree to pay us the charges associated with availing the Services..

</p>
<p>
You agree not to use the Platform and/ or Services for any purpose that is unlawful, illegal or forbidden by these Terms, or Indian or local laws that might apply to you.

</p>





You agree and acknowledge that website and the Services may contain links to other third party websites. On accessing these links, you will be governed by the terms of use, privacy policy and such other policies of such third party websites. These links are provided for your convenience for provide further information..
<br/>
You understand that upon initiating a transaction for availing the Services you are entering into a legally binding and enforceable contract with the Platform Owner for the Services..
<br/>
You shall indemnify and hold harmless Platform Owner, its affiliates, group companies (as applicable) and their respective officers, directors, agents, and employees, from any claim or demand, or actions including reasonable attorney's fees, made by any third party or penalty imposed due to or arising out of Your breach of this Terms of Use, privacy Policy and other Policies, or Your violation of any law, rules or regulations or the rights (including infringement of intellectual property rights) of a third party.
<br/>
Notwithstanding anything contained in these Terms of Use, the parties shall not be liable for any failure to perform an obligation under these Terms if performance is prevented or delayed by a force majeure event..
<br/>
These Terms and any dispute or claim relating to it, or its enforceability, shall be governed by and construed in accordance with the laws of India..
<br/>
All disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in Pune and MH.
<br/>
All concerns or communications relating to these Terms must be communicated to us using the contact information provided on this website
Privacy Policy
<br/>
Introduction
<br/>
This Privacy Policy describes how Treelix and its affiliates (collectively &Treelix, we, our, us) collect, use, share, protect or otherwise process your information/ personal data through our website https://treelix.in/ (hereinafter referred to as Platform). Please note that you may be able to browse certain sections of the Platform without registering with us. We do not offer any product/service under this Platform outside India and your personal data will primarily be stored and processed in India. By visiting this Platform, providing your information or availing any product/service offered on the Platform, you expressly agree to be bound by the terms and conditions of this Privacy Policy, the Terms of Use and the applicable service/product terms and conditions, and agree to be governed by the laws of India including but not limited to the laws applicable to data protection and privacy. If you do not agree please do not use or access our Platform.
<br/>
Collection-We collect your personal data when you use our Platform, services or otherwise interact with us during the course of our relationship.and related information provided from time to time. Some of the information that we may collect includes but is not limited to personal data / information provided to us during sign-up/registering or using our Platform such as name, date of birth, address, telephone/mobile number, email IDand/or any such information shared as proof of identity or address. Some of the sensitive personal data may be collected with your consent, such as your bank account or credit or debit card or other payment instrument information or biometric information such as your facial features or physiological information (in order to enable use of certain features when opted for, available on the Platform) etc all of the above being in accordance with applicable law(s) You always have the option to not provide information, by choosing not to use a particular service or feature on the Platform. We may track your behaviour, preferences, and other information that you choose to provide on our Platform. This information is compiled and analysed on an aggregated basis. We will also collect your information related to your transactions on Platform and such third-party business partner platforms. When such a third-party business partner collects your personal data directly from you, you will be governed by their privacy policies. We shall not be responsible for the third-party business partner?s privacy practices or the content of their privacy policies, and we request you to read their privacy policies prior to disclosing any information. If you receive an email, a call from a person/association claiming to be TREELIX AGRITECH & INDUSTRIES PVT LTD seeking any personal data like debit/credit card PIN, net-banking or mobile banking password, we request you to never provide such information. If you have already revealed such information, report it immediately to an appropriate law enforcement agency.
<br/>
Usage- We use personal data to provide the services you request. To the extent we use your personal data to market to you, we will provide you the ability to opt-out of such uses. We use your personal data to assist sellers and business partners in handling and fulfilling orders; enhancing customer experience; to resolve disputes; troubleshoot problems; inform you about online and offline offers, products, services, and updates; customise your experience; detect and protect us against error, fraud and other criminal activity; enforce our terms and conditions; conduct marketing research, analysis and surveys; and as otherwise described to you at the time of collection of information. You understand that your access to these products/services may be affected in the event permission is not provided to us.
<br/>
Sharing- We may share your personal data internally within our group entities, our other corporate entities, and affiliates to provide you access to the services and products offered by them. These entities and affiliates may market to you as a result of such sharing unless you explicitly opt-out. We may disclose personal data to third parties such as sellers, business partners, third party service providers including logistics partners, prepaid payment instrument issuers, third-party reward programs and other payment opted by you. These disclosure may be required for us to provide you access to our services and products offered to you, to comply with our legal obligations, to enforce our user agreement, to facilitate our marketing and advertising activities, to prevent, detect, mitigate, and investigate fraudulent or illegal activities related to our services. We may disclose personal and sensitive personal data to government agencies or other authorised law enforcement agencies if required to do so by law or in the good faith belief that such disclosure is reasonably necessary to respond to subpoenas, court orders, or other legal process. We may disclose personal data to law enforcement offices, third party rights owners, or others in the good faith belief that such disclosure is reasonably necessary to: enforce our Terms of Use or Privacy Policy; respond to claims that an advertisement, posting or other content violates the rights of a third party; or protect the rights, property or personal safety of our users or the general public.
<br/>
Security Precautions- To protect your personal data from unauthorised access or disclosure, loss or misuse we adopt reasonable security practices and procedures. Once your information is in our possession or whenever you access your account information, we adhere to our security guidelines to protect it against unauthorised access and offer the use of a secure server. However, the transmission of information is not completely secure for reasons beyond our control. By using the Platform, the users accept the security implications of data transmission over the internet and the World Wide Web which cannot always be guaranteed as completely secure, and therefore, there would always remain certain inherent risks regarding use of the Platform. Users are responsible for ensuring the protection of login and password records for their account.
<br/>
Data Deletion and Retention- You have an option to delete your account by visiting your profile and settings on our Platform , this action would result in you losing all information related to your account. You may also write to us at the contact information provided below to assist you with these requests. We may in event of any pending grievance, claims, pending shipments or any other services we may refuse or delay deletion of the account. Once the account is deleted, you will lose access to the account. We retain your personal data information for a period no longer than is required for the purpose for which it was collected or as required under any applicable law. However, we may retain data related to you if we believe it may be necessary to prevent fraud or future abuse or for other legitimate purposes. We may continue to retain your data in anonymised form for analytical and research purposes.
<br/>
Your Rights- You may access, rectify, and update your personal data directly through the functionalities provided on the Platform.
<br/>
Consent- By visiting our Platform or by providing your information, you consent to the collection, use, storage, disclosure and otherwise processing of your information on the Platform in accordance with this Privacy Policy. If you disclose to us any personal data relating to other people, you represent that you have the authority to do so and permit us to use the information in accordance with this Privacy Policy. You, while providing your personal data over the Platform or any partner platforms or establishments, consent to us (including our other corporate entities, affiliates, lending partners, technology partners, marketing channels, business partners and other third parties) to contact you through SMS, instant messaging apps, call and/or e-mail for the purposes specified in this Privacy Policy. You have an option to withdraw your consent that you have already provided by writing to the Grievance Officer at the contact information provided below. Please mention ?Withdrawal of consent for processing personal data? in your subject line of your communication. We may verify such requests before acting on our request. However, please note that your withdrawal of consent will not be retrospective and will be in accordance with the Terms of Use, this Privacy Policy, and applicable laws. In the event you withdraw consent given to us under this Privacy Policy, we reserve the right to restrict or deny the provision of our services for which we consider such information to be necessary.
<br/>
Changes to this Privacy Policy- Please check our Privacy Policy periodically for changes. We may update this Privacy Policy to reflect changes to our information practices. We may alert / notify you about the significant changes to the Privacy Policy, in the manner as may be required under applicable laws.
<br/>
<p>Grievance Officer</p>
<p>
Insert Name of the Office: Aparna, 
Treelix Agritech & Industries PVT LTD
</p>

<p>Designation: 
Director </p>

<p>
Insert Name and Address of the Company: 
Godown No:2 and 3,Floor No: Underground Building No./Flat No.: S No 256, Hissa No 7/1 Road/Street: Hinjewadi Phase 1, Near Vibgyor School Nearby Landmark: Infotech Park Sub Post Office Locality/Sub Locality: Hinjewadi City/Town/Village: Pune District: Pune State: Maharashtra PIN Code: 411057 

</p>

<p>
Contact us: 
+91 88550 67337
</p>


<p>Phone: Time: Monday - Friday(9:00 - 18:00)
</p>
    </div>
  );
};

export default TermsAndConditions;


// import React from 'react';
// import PrivacyPolicy from '../../components/PrivacyPolicy';

// let comp=  return(
//   <div className="terms-container">
//     <h1>Terms & Conditions</h1>
    
//     <section>
//       <h2>Introduction</h2>
//       <p>
//         This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
//       </p>
//     </section>

//     <section>
//       <h2>Platform Information</h2>
//       <p>
//         This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of domain name <a href="https://treelix.in/">https://treelix.in/</a> ('Website'), including the related mobile site and mobile application (hereinafter referred to as 'Platform').
//       </p>
//       <p>
//         The Platform is owned by TREELIX AGRITECH & INDUSTRIES PVT LTD, a company incorporated under the Companies Act, 1956 with its registered office at:
//         <address>
//           Godown No:2 and 3, Floor No: Underground Building No./Flat No.: S No 256, Hissa No 7/1 Road/Street: Hinjewadi Phase 1, Near Vibgyor School Nearby Landmark: Infotech Park Sub Post Office Locality/Sub Locality: Hinjawadi City/Town/Village: Pune District: Pune State: Maharashtra PIN Code: 411057
//         </address>
//       </p>
//     </section>

//     <section>
//       <h2>Agreement to Terms</h2>
//       <p>
//         By using the Platform, you agree to these Terms of Use. If you transact on the Platform, you are bound by the applicable policies and terms. The Platform Owner may modify these Terms at any time without notice, and it is your responsibility to review them periodically.
//       </p>
//     </section>

//     <section>
//       <h2>Accessing and Using the Platform</h2>
//       <p>
//         To access and use the Services, you agree to provide true, accurate, and complete information during and after registration. You are responsible for all actions taken through your registered account.
//       </p>
//       <p>
//         The contents of the Platform and Services are proprietary to TREELIX AGRITECH & INDUSTRIES PVT LTD and are licensed to the company. Unauthorized use may result in legal actions.
//       </p>
//     </section>

//     <section>
//       <h2>Limitation of Liability</h2>
//       <p>
//         Neither we nor any third parties provide any warranty or guarantee regarding the accuracy, timeliness, or completeness of the information and materials on the website.
//       </p>
//     </section>

//     <section>
//       <h2>Indemnification</h2>
//       <p>
//         You agree to indemnify and hold harmless the Platform Owner, its affiliates, and their officers, directors, and employees from any claims or demands arising out of your breach of these Terms of Use.
//       </p>
//     </section>

//     <section>
//       <h2>Jurisdiction</h2>
//       <p>
//         Any disputes relating to these Terms will be governed by Indian law, and you consent to the exclusive jurisdiction of courts in Pune, Maharashtra.
//       </p>
//     </section>

//     <section>
//       <h2>Privacy Policy</h2>
//       <p>
//         This Privacy Policy describes how TREELIX collects, uses, shares, and protects your personal information through our Platform.
//       </p>

//       <h3>Collection of Data</h3>
//       <p>
//         We collect personal data when you use our Platform, such as your name, contact details, and transaction information. We may also collect sensitive personal data with your consent, such as financial details and biometric data.
//       </p>

//       <h3>Usage of Data</h3>
//       <p>
//         We use personal data to provide services, process transactions, and improve user experience. We may also use this data for marketing purposes, and you can opt-out at any time.
//       </p>

//       <h3>Sharing of Data</h3>
//       <p>
//         We may share your data with third-party service providers, sellers, or legal authorities as necessary to provide services, comply with laws, or prevent fraud.
//       </p>

//       <h3>Security of Data</h3>
//       <p>
//         We adopt reasonable security practices to protect your personal data from unauthorized access. However, the transmission of data over the internet is not entirely secure, and you accept the inherent risks.
//       </p>

//       <h3>Retention and Deletion of Data</h3>
//       <p>
//         You can delete your account at any time, and we will retain your personal data only as long as necessary or as required by law.
//       </p>

//       <h3>Your Rights</h3>
//       <p>
//         You can access, rectify, or update your personal data through the Platform. You can also withdraw consent for processing your data.
//       </p>

//       <h3>Changes to Privacy Policy</h3>
//       <p>
//         We may update this Privacy Policy from time to time. Significant changes will be notified to you.
//       </p>
//     </section>

//     <section>
//       <h2>Grievance Officer</h2>
//       <p>
//         Name: Aparna (Director) <br />
//         Company Address: Godown No:2 and 3, Floor No: Underground Building No./Flat No.: S No 256, Hissa No 7/1 Road/Street: Hinjewadi Phase 1, Pune, Maharashtra, PIN: 411057 <br />
//         Contact: +91 88550 67337 <br />
//         Working Hours: Monday - Friday (9:00 AM - 6:00 PM)
//       </p>
//     </section>
//   </div>
// );

// function Policy() {
//   return (
//     <div>
//       <PrivacyPolicy />
//     </div>
//   );
// }

// export default Policy;

